import { setValue } from "../Components/API/ApiCalling";
import {
  checkZohoAuth,
  getAllUserData,
  getLoginUserData,
  getOrgVariable,
  getOrgVariableList,
  getTokens,
  setOrgId,
  setUpDataCenter,
  setUpDataCenterUrl,
  setUpDefaultAuthenticator,
  setUpOrgVariable,
} from "../Components/API/ZohoAPICalling";

import {
  API_KEY_API_NAME,
  DATA_CENTER_API_NAME,
  DEFAULT_VIEW_API_NAME,
  ORG_ID_API_NAME,
  PAGE_SIZE_API_NAME,
  HIDE_LOGO_API_NAME,
  ZUID_API_NAME,
  Z_API_KEY_API_NAME,
  Use_Login_User_Credential_API_NAME,
  Default_Authenticator_API_NAME,
  EXTENSION_IDENTIFIER,
  DATA_CENTER_URL_API_NAME,
} from "../config/serviceConstant";

const ZOHO = window.ZOHO;
const authCheckZoho = async ({
  orgId,
  apiKey,
  dataCenterUrl,
  dataCenter,
  connName,
}) => {
  try {
    if (!orgId || !apiKey || !dataCenter || !connName) {
      return false;
    }
    const zohoHeaders = {
      orgid: orgId,
      connname: connName,
      apikey: apiKey,
      datacenter: dataCenter,
      datacenterurl: dataCenterUrl,
    };
    return await checkZohoAuth(zohoHeaders);
  } catch (error) {
    return false;
  }
};

const getZohoTokens = async ({ orgId, apiKey }) => {
  try {
    if (!orgId || !apiKey) {
      return false;
    }
    const zohoHeaders = {
      orgid: orgId,
      apikey: apiKey,
      connname: `${EXTENSION_IDENTIFIER}__zoho`,
    };
    return await getTokens(zohoHeaders);
  } catch (error) {
    return false;
  }
};

export async function initZoho(callback) {
  try {
    ZOHO.embeddedApp.on("PageLoad", async function () {
      const orgVariableList = [
        DATA_CENTER_URL_API_NAME,
        ORG_ID_API_NAME,
        API_KEY_API_NAME,
        DATA_CENTER_URL_API_NAME,
        Use_Login_User_Credential_API_NAME,
        Default_Authenticator_API_NAME,
        DEFAULT_VIEW_API_NAME,
        PAGE_SIZE_API_NAME,
        ZUID_API_NAME,
        DATA_CENTER_API_NAME,
        HIDE_LOGO_API_NAME,
      ];

      let extensionData = {};
      let fetchOrgVaribalePromise = [];
      fetchOrgVaribalePromise.push(setUpDataCenterUrl(ZOHO));
      fetchOrgVaribalePromise.push(getOrgVariable(ZOHO, ORG_ID_API_NAME));
      fetchOrgVaribalePromise.push(getOrgVariable(ZOHO, API_KEY_API_NAME));
      fetchOrgVaribalePromise.push(setUpDataCenter(ZOHO));
      fetchOrgVaribalePromise.push(
        getOrgVariable(ZOHO, Use_Login_User_Credential_API_NAME)
      );

      fetchOrgVaribalePromise.push(
        getOrgVariable(ZOHO, Default_Authenticator_API_NAME)
      );
      fetchOrgVaribalePromise.push(getLoginUserData(ZOHO));

      let primaryData = await Promise.all(fetchOrgVaribalePromise)
        .then((response) => response)
        .catch((error) => null);

      const dataCenterUrl = primaryData[0];
      const orgId = primaryData[1];
      const apiKey = primaryData[2];
      const dataCenter = primaryData[3];
      const useLoginUserCredential = primaryData?.[4] == "ON" ? true : false;
      let defaultAuthenticator = primaryData[5];
      const currentUser = primaryData[6];

      if (!defaultAuthenticator) {
        // set defaultAuthenticator
        await setUpDefaultAuthenticator(ZOHO, currentUser?.email);
        defaultAuthenticator = currentUser?.email;

        try {
          const uniqueKey = `${orgId}__${EXTENSION_IDENTIFIER}__orgvariables`;
          await setValue({ key: uniqueKey, value: "" });
        } catch (error) {}
      }

      let connName = `${EXTENSION_IDENTIFIER}__zoho__${currentUser?.email}`;
      if (!useLoginUserCredential) {
        connName = `${EXTENSION_IDENTIFIER}__zoho__${defaultAuthenticator}`;
      }

      let secondaryVarPromise = [];
      secondaryVarPromise.push(
        authCheckZoho({
          orgId,
          apiKey,
          dataCenterUrl,
          dataCenter,
          connName,
        })
      );
      secondaryVarPromise.push(setUpDataCenter(ZOHO)); // 1
      secondaryVarPromise.push(getOrgVariable(ZOHO, Z_API_KEY_API_NAME)); // 2
      secondaryVarPromise.push(getOrgVariable(ZOHO, ZUID_API_NAME)); // 3
      secondaryVarPromise.push(getOrgVariable(ZOHO, HIDE_LOGO_API_NAME)); //4
      secondaryVarPromise.push(getAllUserData(ZOHO)); // 5
      secondaryVarPromise.push(
        getZohoTokens({
          orgId: orgId,
          apiKey: apiKey,
        })
      ); //6
      secondaryVarPromise.push(getOrgVariable(ZOHO, DEFAULT_VIEW_API_NAME)); // 7
      secondaryVarPromise.push(getOrgVariable(ZOHO, PAGE_SIZE_API_NAME)); // 8

      let secondaryData = await Promise.all(secondaryVarPromise)
        .then((response) => response)
        .catch((error) => null);

      const zohoAuth = secondaryData[0];
      const zApiKey = secondaryData[2];
      const zuid = secondaryData[3];
      const hideLogo = secondaryData?.[4] == "ON" ? true : false;

      const allUser = secondaryData[5];
      const zohoTokens = secondaryData[6];
      const view = secondaryData[7];
      const pageSize = secondaryData[8];


      let authenticatedUserMap = {};
      zohoTokens?.forEach((token) => {
        const userEmail = token?.service_name?.split("__")?.[3];
        const platform = token?.service_name?.split("__")?.[2];
        authenticatedUserMap[userEmail] = {
          email: userEmail,
          role: token?.role,
          platform: platform,
        };
        if (currentUser?.email === userEmail) {
          currentUser["extensionRole"] = token?.role;
        }
      });

      extensionData["zohoAuth"] = zohoAuth;
      extensionData["orgId"] = orgId;
      extensionData["apiKey"] = apiKey;
      extensionData["dataCenterUrl"] = dataCenterUrl;
      extensionData["dataCenter"] = dataCenter;
      extensionData["zApiKey"] = zApiKey;
      extensionData["zuid"] = zuid;
      extensionData["hideLogo"] = hideLogo;
      extensionData["useLoginUserCredential"] = useLoginUserCredential;
      extensionData["currentUser"] = currentUser;
      extensionData["allUser"] = allUser;
      extensionData["zohoLoaded"] = true;
      extensionData["connName"] = connName;
      extensionData["view"] = view;
      extensionData["authenticatedUserMap"] = authenticatedUserMap;
      extensionData["defaultAuthenticator"] = defaultAuthenticator;
      extensionData["pageSize"] = pageSize;

      callback(null, extensionData);
    });
    ZOHO.embeddedApp.init().then(() => {});
  } catch (initZohoError) {
    callback(initZohoError, null);
  }
}

export async function initZohoForRelatedList(callback) {
  try {
    ZOHO.embeddedApp.on("PageLoad", async function (data) {
      let extensionData = {};
      ///////////////////////////////////////////////////////////////////////////////////////
      // Primary data
      let fetchOrgVaribalePromise = [];
      const orgVariableList = [
        ORG_ID_API_NAME,
        API_KEY_API_NAME,
        DATA_CENTER_API_NAME,
        DATA_CENTER_URL_API_NAME,
        Use_Login_User_Credential_API_NAME,
        Default_Authenticator_API_NAME,
        DEFAULT_VIEW_API_NAME,
        PAGE_SIZE_API_NAME,
        ZUID_API_NAME,
        HIDE_LOGO_API_NAME,
      ];
      // orgVariables?.Success?.Content?.easysharepointforcrm__API_KEY?.value
      fetchOrgVaribalePromise.push(getLoginUserData(ZOHO));
      fetchOrgVaribalePromise.push(getOrgVariableList(ZOHO, orgVariableList));

      let primaryData = await Promise.all(fetchOrgVaribalePromise)
        .then((response) => response)
        .catch((error) => null);

      const currentUser = primaryData[0];
      const allData = primaryData?.[1];

      const defaultView = allData?.[DEFAULT_VIEW_API_NAME] || "list";
      const pageSize = allData?.[PAGE_SIZE_API_NAME] || 10;
      const zuid = allData?.[ZUID_API_NAME];
      const hideLogo = allData?.[HIDE_LOGO_API_NAME] == "ON" ? true : false;

      const orgId = allData?.[ORG_ID_API_NAME];
      const apiKey = allData?.[API_KEY_API_NAME];
      const dataCenter = allData?.[DATA_CENTER_API_NAME];
      const dataCenterUrl = allData?.[DATA_CENTER_URL_API_NAME];

      const useLoginUserCredential =
        allData?.[Use_Login_User_Credential_API_NAME];
      const defaultAuthenticator = allData?.[Default_Authenticator_API_NAME];

      let connName = `${EXTENSION_IDENTIFIER}__zoho__${currentUser?.email}`;
      if (useLoginUserCredential == "OFF") {
        connName = `${EXTENSION_IDENTIFIER}__zoho__${defaultAuthenticator}`;
        extensionData["role"] = "Admin";
      }

      ///////////////////////////////////////////////////////////////////////////////////////
      // Secondary data
      let secondaryVarPromise = [];
      secondaryVarPromise.push(
        authCheckZoho({
          orgId,
          apiKey,
          dataCenterUrl,
          dataCenter,
          connName,
        })
      ); // 0

      secondaryVarPromise.push(
        getZohoTokens({
          orgId: orgId,
          apiKey: apiKey,
        })
      ); //6

      let secondaryData = await Promise.all(secondaryVarPromise)
        .then((response) => response)
        .catch((error) => null);

      const zohoAuth = secondaryData[0];
      const zohoTokens = secondaryData[1];


      let authenticatedUserMap = {};
      zohoTokens?.forEach((token) => {
        const userEmail = token?.service_name?.split("__")?.[3];
        const platform = token?.service_name?.split("__")?.[2];
        authenticatedUserMap[userEmail] = {
          email: userEmail,
          role: token?.role,
          platform: platform,
        };
      });

      if (
        authenticatedUserMap[currentUser?.email] &&
        useLoginUserCredential != "OFF"
      ) {
        extensionData["role"] = authenticatedUserMap[currentUser?.email]?.role;
      }

      extensionData["zohoAuth"] = zohoAuth;
      extensionData["orgId"] = orgId;
      extensionData["apiKey"] = apiKey;
      extensionData["dataCenterUrl"] = dataCenterUrl;
      extensionData["dataCenter"] = dataCenter;
      extensionData["defaultView"] = defaultView;
      extensionData["pageSize"] = pageSize;
      extensionData["zuid"] = zuid;
      extensionData["dataCenter"] = dataCenter;
      extensionData["hideLogo"] = hideLogo;
      extensionData["connName"] = connName;

      extensionData["Entity"] = data?.Entity;
      extensionData["EntityId"] = data?.EntityId;
      extensionData["zohoLoaded"] = true;
      callback(null, extensionData);
    });
    ZOHO.embeddedApp.init().then(() => {});
  } catch (initZohoError) {
    callback(initZohoError, null);
  }
}

export async function initZohoForCustomAction(callback) {
  try {
    ZOHO.embeddedApp.on("PageLoad", async function (data) {
      let extensionData = {};
      let fetchOrgVaribalePromise = [];
      fetchOrgVaribalePromise.push(setUpDataCenterUrl(ZOHO));
      fetchOrgVaribalePromise.push(getOrgVariable(ZOHO, ORG_ID_API_NAME));
      fetchOrgVaribalePromise.push(getOrgVariable(ZOHO, API_KEY_API_NAME));
      fetchOrgVaribalePromise.push(setUpDataCenter(ZOHO));

      fetchOrgVaribalePromise.push(
        getOrgVariable(ZOHO, Use_Login_User_Credential_API_NAME)
      );

      fetchOrgVaribalePromise.push(
        getOrgVariable(ZOHO, Default_Authenticator_API_NAME)
      );
      fetchOrgVaribalePromise.push(getLoginUserData(ZOHO));

      let primaryData = await Promise.all(fetchOrgVaribalePromise)
        .then((response) => response)
        .catch((error) => null);

      const dataCenterUrl = primaryData[0];
      const orgId = primaryData[1];
      const apiKey = primaryData[2];
      const dataCenter = primaryData[3];
      const useLoginUserCredential = primaryData?.[4] == "ON" ? true : false;
      const defaultAuthenticator = primaryData[5];
      const currentUser = primaryData[6];

      let connName = `${EXTENSION_IDENTIFIER}__zoho__${currentUser?.email}`;
      if (!useLoginUserCredential) {
        connName = `${EXTENSION_IDENTIFIER}__zoho__${defaultAuthenticator}`;
      }

      let secondaryVarPromise = [];
      secondaryVarPromise.push(
        authCheckZoho({
          orgId,
          apiKey,
          dataCenterUrl,
          dataCenter,
          connName,
        })
      ); // 0
      secondaryVarPromise.push(setUpDataCenter(ZOHO)); // 1
      secondaryVarPromise.push(getOrgVariable(ZOHO, Z_API_KEY_API_NAME)); // 2
      secondaryVarPromise.push(getOrgVariable(ZOHO, ZUID_API_NAME)); // 3
      secondaryVarPromise.push(getOrgVariable(ZOHO, HIDE_LOGO_API_NAME)); //4
      secondaryVarPromise.push(getAllUserData(ZOHO)); // 5
      secondaryVarPromise.push(
        getZohoTokens({
          orgId: orgId,
          apiKey: apiKey,
        })
      ); //6
      secondaryVarPromise.push(getOrgVariable(ZOHO, DEFAULT_VIEW_API_NAME)); // 7
      secondaryVarPromise.push(getOrgVariable(ZOHO, PAGE_SIZE_API_NAME)); // 8

      let secondaryData = await Promise.all(secondaryVarPromise)
        .then((response) => response)
        .catch((error) => null);

      const zohoAuth = secondaryData[0];
      // const dataCenter = secondaryData[1];
      const zApiKey = secondaryData[2];
      const zuid = secondaryData[3];
      const hideLogo = secondaryData?.[4] == "ON" ? true : false;

      const allUser = secondaryData[5];
      const zohoTokens = secondaryData[6];


      let authenticatedUserMap = {};
      zohoTokens?.forEach((token) => {
        const userEmail = token?.service_name?.split("__")?.[3];
        const platform = token?.service_name?.split("__")?.[2];
        authenticatedUserMap[userEmail] = {
          email: userEmail,
          role: token?.role,
          platform: platform,
        };
      });

      extensionData["zohoAuth"] = zohoAuth;
      extensionData["orgId"] = orgId;
      extensionData["apiKey"] = apiKey;
      extensionData["dataCenterUrl"] = dataCenterUrl;
      extensionData["dataCenter"] = dataCenter;
      extensionData["zApiKey"] = zApiKey;
      extensionData["zuid"] = zuid;
      extensionData["hideLogo"] = hideLogo;
      extensionData["data"] = data;
      extensionData["zohoLoaded"] = true;

      extensionData["useLoginUserCredential"] = useLoginUserCredential;
      extensionData["currentUser"] = currentUser;
      extensionData["allUser"] = allUser;
      extensionData["connName"] = connName;
      extensionData["authenticatedUserMap"] = authenticatedUserMap;

      callback(null, extensionData);
    });
    ZOHO.embeddedApp.init().then(() => {});
  } catch (initZohoError) {
    callback(initZohoError, null);
  }
}
